// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__34pWh","Nav":"Header_Nav__j4qzf","NavLink":"Header_NavLink__30dug","ActiveNavLink":"Header_ActiveNavLink__30vvh","Logo":"Header_Logo__3rezB"};